/**
 * The max file size we accept for upload.
 *
 * Custom (Vianova): files are uploaded out-of-band via XEP-0363 (HTTP File Upload), so the
 * bytes no longer travel over the XMPP signaling channel. The server (Prosody
 * mod_http_file_share) enforces its own limit; keep this in sync with it.
 */
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
